<div class="line-wrapper" [class.hover]="hover">
  <div class="max-wrapper" [style.width]="max + '%'">
    <div class="line"></div>
  </div>
</div>
